var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.09269 9.35825V2.18996L7.98502 5.32167C8.21617 5.57196 8.59549 5.57196 8.82664 5.32167C9.05779 5.07139 9.05779 4.66709 8.82664 4.41681L4.92081 0.187711C4.68966 -0.0625702 4.31627 -0.0625702 4.08512 0.187711L0.173362 4.4104C-0.0577873 4.66068 -0.0577873 5.06498 0.173362 5.31526C0.404511 5.56554 0.777906 5.56554 1.00906 5.31526L3.90731 2.18996V9.35825C3.90731 9.71121 4.17402 10 4.5 10C4.82598 10 5.09269 9.71121 5.09269 9.35825Z",
    fill: "#85D4B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrowth);
export default __webpack_public_path__ + "static/media/icon-growth.ea8aa65d5774b4b2c0ffb6a979fd6a6b.svg";
export { ForwardRef as ReactComponent };